import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { logout } from '../../../store/index';
import { mdiArrowLeft } from '@mdi/js';
import Icon from '@mdi/react';

const SimpleFrame = (props) => {
  const { children, goBack, NotCenter, style } = props;
  const dispatch = useDispatch();

  const LogBack = useMemo(() => {
    return {
      wrapper_div: {
        position: 'absolute',
        top: '20px',
        left: '20px',
        display: 'flex',
      },
      Log: {
        color: 'rgb(229, 148, 0)',
        cursor: 'pointer',
        marginLeft: goBack ? '3rem' : '10px',
      },
    };
  }, [goBack]);

  return (
    <div className='normalBox'>
      <div className={!NotCenter ? 'center' : ''} style={{ ...style }}>
        <div style={LogBack.wrapper_div}>
          {goBack && (
            <NavLink to={`${goBack}`}>
              <Icon path={mdiArrowLeft} size={1} title='go back' />
            </NavLink>
          )}
          <div style={LogBack.Log} onClick={() => dispatch(logout())}>
            logout
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default SimpleFrame;
